export { default as CloudUploadSolidIcon } from './CloudUploadSolidIcon';
